import FlightSeats from './FlightSeats';

export default FlightSeats;
